import { useLang } from "../i18n";

const items = [
    { en: "Gate Openers", hi: "गेट ओपनर" },
    { en: "Door Openers", hi: "डोर ओपनर" },
    { en: "Pedestrian Openers", hi: "पैदल ओपनर" },
    { en: "Parking Barriers", hi: "पार्किंग बैरियर" },
    { en: "Access Control Devices", hi: "एक्सेस कंट्रोल डिवाइस" },
    { en: "Card & Biometric Readers", hi: "कार्ड व बायोमेट्रिक रीडर" },
    { en: "Software Solutions", hi: "सॉफ्टवेयर सॉल्यूशन" },
];

export default function Marquee() {
    const { lang } = useLang();
    return (
        <div
            data-testid="editorial-marquee"
            className="marquee-hover overflow-hidden border-y border-hairline bg-white py-5"
        >
            <div className="animate-marquee flex w-max">
                {[0, 1].map((copy) => (
                    <div key={copy} className="flex items-center" aria-hidden={copy === 1}>
                        {items.map((t) => (
                            <span key={`${copy}-${t.en}`} className="flex items-center">
                                <span className="whitespace-nowrap px-8 font-display text-xl uppercase tracking-wide text-charcoal/85 md:text-3xl">
                                    {t[lang]}
                                </span>
                                <span className="h-2 w-2 rotate-45 bg-brand" />
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}
